import firebase from "firebase/app";
import "firebase/auth";


const app = firebase.initializeApp({

  apiKey: "AIzaSyBd0Bj6wWxK4jCF3zvcyaQEK_-86jh1Wnk",
  authDomain: "test-7af74.firebaseapp.com",
  databaseURL: "https://test-7af74-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "test-7af74",
  storageBucket: "test-7af74.appspot.com",
  messagingSenderId: "92908809850",
  appId: "1:92908809850:web:3efc2c89502f41c40f15c3",
  measurementId: "G-92RCGWD0VN"

  //   //Shalithas SDK
  //   apiKey: "AIzaSyAiYL6slhsrzJHCI8u-vPmgBkGdJzogjKs",
  // authDomain: "superadmin-93c17.firebaseapp.com",
  // databaseURL: "https://superadmin-93c17-default-rtdb.firebaseio.com",
  // projectId: "superadmin-93c17",
  // storageBucket: "superadmin-93c17.appspot.com",
  // messagingSenderId: "521731572844",
  // appId: "1:521731572844:web:b2f0c8cf48d39912b64449",
  // measurementId: "G-X2VYY8K98H"

})

export const auth = app.auth()
export default app
  